import { SystemIcon, Typography } from '@volvo/vcdk-react';
import React from 'react';

const Success: React.FC = () => (
  <div style={{ display: 'flex', gap: '.4rem', alignItems: 'center' }}>
    <Typography style={{ color: 'textSecondary' }}>Successfully installed</Typography>
    <SystemIcon icon="check" />
  </div>
);

export default Success;
